<template>
  <div class="text-sm text-gray-700 font-light bg-gray-100">
    <layouts-auth-width>
      <div class="p-4">
        <div class="pl-2 pb-2 font-bold text-red-500 hover:text-red-400">
          <router-link to="/recommend">あなたにおすすめの講座</router-link>
        </div>
        <ul class="md:flex mb-2">
          <div class="pb-1">
            <li class="md:border-r border-gray-300 px-2 hover:text-gray-500">
              <router-link to="/contact">{{ t('contact.title') }}</router-link>
            </li>
          </div>
          <div class="pb-1">
            <li class="md:border-r border-gray-300 px-2 hover:text-gray-500">
              <router-link to="/terms">ご利用規約</router-link>
            </li>
          </div>
          <div>
            <li class="pl-2 hover:text-gray-500">
              <router-link to="/account">{{ t('word.setting') }}</router-link>
            </li>
          </div>
        </ul>
        <div class="pl-2">
          &copy; {{new Date().getFullYear()}} ウイニングクルー株式会社
        </div>
      </div>
    </layouts-auth-width>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: { LayoutsAuthWidth },
  setup() {
    const { t } = useI18n()

    return {
      t
    }
  },
})
</script>
